import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { BsLocaleService, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SessionService } from '@parashift/shared/services';

type Placement = 'left' | 'right' | 'top' | 'bottom';

@Component({
    selector: 'datepicker-type',
    templateUrl: './datepicker.component.html',
    imports: [FaIconComponent, BsDatepickerModule, ReactiveFormsModule, FormlyModule]
})
export class DatepickerComponent extends FieldType<FieldTypeConfig> {
  private localeService = inject(BsLocaleService);
  protected sessionService = inject(SessionService);

  get datepickerFormControl(): FormControl {
    return this.formControl as FormControl;
  }

  get placement(): Placement {
    return (this.props.placement || 'bottom') as Placement;
  }

  get dateFormat(): string {
    return this.props.dateFormat || 'DD-MM-YYYY';
  }

  get minDate(): Date {
    return this.props.minDate || null;
  }

  get maxDate(): Date {
    return this.props.maxDate || null;
  }

  constructor() {
    super();
    this.localeService.use(this.sessionService.user.language);
  }
}
